export default {
  data () {
    return {
      portalType: Object.freeze({
        'Game': 'game',
        'Music': 'music'
      }),
      profileTab: Object.freeze({
        'Demographic': 'Demographic',
        'Wallet': 'Wallet',
        'ProductHistory': 'ProductHistory',
        'Subscription': 'Subscription'
      }),
      planType: Object.freeze({
        'Yearly': 'Yearly',
        'Monthly': 'Monthly',
        'Weekly': 'Weekly',
        'Daily': 'Daily'
      })
    }
  }
}
